import {createZip, importZip, uploadZip } from './io';
import { Promise } from 'es6-promise';
import types from '../store/types';
import store from '../store/store';
import { IdHelper, IJourneyItem, IAdminToolPanel, AdminToolPanelHelper, UpgradeHelper, clone, IExportZip, AdminToolHelper } from './';
import {PANEL_VALUE_ZIP_UPLOADED} from '../constants';
declare var jQuery;

export class JourneyImportAndExportHelper {


    /**
    * Add the zip file data to  the download list state
    * @static
    * @memberOf JourneyImportAndExportHelper
    **/
    public static AddZipToList(zip:any, name:any, adminToolState:any) {
        let panel:IAdminToolPanel = AdminToolPanelHelper.GetPanel(adminToolState, "exportscreen_zipimport");
        let getZipList:IExportZip[] = AdminToolPanelHelper.GetPanelValueFromState(panel, "ziplist") as IExportZip[];

        if (!getZipList) {
            getZipList = [];
        }

        getZipList.push({ file: zip, fileName: name });

        AdminToolPanelHelper.AddOrUpdatePanelValue("exportscreen_zipimport", "ziplist", getZipList)

    }

    /**
    *  Sends the zip file to the API and returns an list of journeys that the zip file contains
    * and then adds it to the process list
    * @static
    * @memberOf JourneyImportAndExportHelper
    **/
    public static GetZipInfo(zip:any, panelName:string): Promise<any> {
        let promise = new Promise<any>((resolve, reject) => {
            uploadZip(zip).then(
                (response) => {
                    let getState = store.getState();
                    let panel:IAdminToolPanel = AdminToolPanelHelper.GetPanel(getState.adminToolState, panelName);
                    if (response.error) {
                        AdminToolPanelHelper.AddErrorMessagesToState(panel, response.error.message)
                    }
                    else {
                        let listJourneyItem:IJourneyItem[] = [];
                        response.data.forEach(item => {
                            listJourneyItem.push({ journeyId: item.journeyId, journeyName: item.journeyName, version: item.version, upgradeStatus: 'Pending Import' })
                        });

                        AdminToolHelper.AddToProccessList(listJourneyItem);
                        let zipUploaded:boolean = true;
                        AdminToolPanelHelper.AddOrUpdatePanelValue(panelName, PANEL_VALUE_ZIP_UPLOADED, zipUploaded);
                    }
                    AdminToolPanelHelper.SetPanelIsLoading(panel.panelName,false);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });

        return promise;
    }

    /**
    *  Calls the import API.
    * @static
    * @memberOf JourneyImportAndExportHelper
    **/
    public static UploadAndImportZip(zip:any, upgradeId:string): Promise<any> {
        let promise = new Promise<any>((resolve, reject) => {
            importZip(zip, upgradeId).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });

        return promise;
    }



     /**
    *  Calls the API to create the zip file
    *  and then adds it to the download list state.
    * @static
    * @memberOf JourneyImportAndExportHelper
    **/
    public static CreateZipFile(completeGuidsList:string[], runId:string, guidsList:string[], index:number, count:number, journeyPerZip:number, zipNumber:number,includeRelatedServiceTypes:boolean): Promise<any> {
        let promise = new Promise<any>((resolve, reject) => {
            createZip(guidsList, runId,zipNumber,includeRelatedServiceTypes).then(
                (response) => {
                    //get latest state
                    let getState:any = store.getState();
                    let blob:any = new Blob([response.file], { type: 'application/zip' });
                    this.AddZipToList(window.URL.createObjectURL(blob), response.filename, getState.adminToolState);
                    let runJourneyNum:number = (count >= journeyPerZip) ? journeyPerZip : count;

                    if (count > 0) {

                        let list:any = clone(completeGuidsList).splice(index, runJourneyNum);
                        index += runJourneyNum;
                        count -= runJourneyNum;

                        this.CreateZipFile(completeGuidsList, runId, list, index, count, journeyPerZip,zipNumber +1,includeRelatedServiceTypes).then((response) => {
                            resolve(response);

                        }, (error) => {
                            console.log("error" + error);
                        })
                    }
                    else {
                        resolve(response);
                    }
                },
                (error) => {
                    reject(error);
                }
            );
        });
        return promise;

    }

    /**
    *  Start creating the zip files
    * @static
    * @memberOf JourneyImportAndExportHelper
    **/
    public static StartCreatingZipFiles(upgradeId:string,includeRelatedServiceTypes:boolean): Promise<any> {

        let getState:any = store.getState();
        let mapGuids:IJourneyItem[] = getState.adminToolState.processList[getState.adminToolState.tab];
        let guidsList:string[] = mapGuids.map((value:IJourneyItem, index:number) => {
            return value.journeyId;
        });

        let index:number = 0;
        let count:number = guidsList.length
        let journeyPerZip:number = 1000;
        let max:number = (count >= journeyPerZip) ? journeyPerZip : count;
        count -= max;
        let list = clone(guidsList)
        if (count != 0) {
            list = list.splice(index, max);
        }
        index += max;

        return this.CreateZipFile(guidsList, upgradeId, list, index, count, journeyPerZip,1,includeRelatedServiceTypes)
    }



    /**
    *  Start the import process.
    * @static
    * @memberOf JourneyImportAndExportHelper
    **/
    public static StartUpImportProcess(processList:any, formData:any) {
        let getState:any = store.getState();
        let journeyId:string = getState.adminToolState.processList[getState.adminToolState.tab][0].journeyId;
        AdminToolHelper.SetUpgradingProcess(true, journeyId, 0);
        JourneyImportAndExportHelper.UploadAndImportZip(formData, getState.adminToolState.UpgradeId).then(() => {
            setTimeout(() => {
                AdminToolHelper.SetUpgradingProcess(false, "", 0);
            }, 1000);
        });
        AdminToolHelper.GetLoggingFor(journeyId, getState.adminToolState.UpgradeId, getState.adminToolState.advancedLogging);
    }

    /**
    *  Start the export process.
    * @static
    * @memberOf JourneyImportAndExportHelper
    **/
    public static StartUpExportProcess(processList:any, journeysPerZip:number, includeRelatedServiceTypes:boolean) {
        let getState:any = store.getState();
        let journeyId:string = getState.adminToolState.processList[getState.adminToolState.tab][0].journeyId;
        AdminToolHelper.SetUpgradingProcess(true, journeyId, 0);
        JourneyImportAndExportHelper.StartCreatingZipFiles(getState.adminToolState.UpgradeId,includeRelatedServiceTypes).then(() => {
            setTimeout(() => {
                AdminToolHelper.SetUpgradingProcess(false, "", 0);
            }, 1000);

        });
        AdminToolHelper.GetLoggingFor(journeyId, getState.adminToolState.UpgradeId, getState.adminToolState.advancedLogging);
    }
}


// WEBPACK FOOTER //
// ./source/ts/helpers/journeyimportandexporthelper.ts